import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-thankyou',
  imports: [TranslatePipe],
  template: `
    <section class="d-flex flex-column flex-grow-1">
      <p class="text-center title mb-1">{{ 'setupCompleted' | translate }}</p>
      <p class="text-center">{{ 'takeToDashboard' | translate }}</p>
    </section>
  `,
})
export class Thankyou {}
